import Phaser from 'phaser';
import gameState from 'tower/state/game-state';
import * as C from 'tower/constants';
import BattleScene from '.';
import { asyncPlaySound } from 'tower/util';

export default class Item extends Phaser.GameObjects.Sprite {
  declare scene: BattleScene;
  declare body: Phaser.Physics.Arcade.Body;

  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    public type: C.ItemKey,
    public id?: string,
    public roomKey?: string,
  ) {
    const itemConfig = C.ITEMS[type];

    super(scene, x, y, 'items', itemConfig.itemFrame);
    scene.add.existing(this);
    scene.physics.add.existing(this);
    this.setDepth(C.DEPTHS.Items);

    if (itemConfig.bodySize) {
      this.body.setSize(itemConfig.bodySize.width, itemConfig.bodySize.height);
    } else {
      this.body.setSize(14, 14);
    }

    if (itemConfig.animation && !gameState.getFlag('disableFlashing')) {
      this.play(itemConfig.animation);
    }
  }

  async collect() {
    const { scene } = this;
    const { player } = scene;

    this.emit('collect');
    this.destroy();

    if (this.id && this.roomKey) {
      gameState.removeRoomItem(this.roomKey, this.id);
    }

    // Special case items
    if (this.type === 'key') {
      gameState.addKey(this.roomKey!);
    } else if (this.type === 'smallHeart') {
      gameState.hp += 2;
    } else {
      gameState.addItem(this.type);
    }

    if (C.ITEMS[this.type].longCollectAnim) {
      scene.freeze();
      scene.stopMusic();

      const itemImage = scene.add.image(this.x, this.y, 'items', C.ITEMS[this.type].itemFrame).setDepth(C.DEPTHS.Items);
      player.holdItem(itemImage);

      const pickupPromises = [asyncPlaySound(Item.bigItemSound)];
      if (this.type.startsWith('heart')) {
        pickupPromises.push(scene.healPlayer(100));
      }
      await Promise.all(pickupPromises);

      itemImage.destroy();
      player.idle();
      scene.playMusic();
      scene.unfreeze();
    } else {
      scene.sound.play('item');
    }
  }

  static bigItemSound: Phaser.Sound.BaseSound;

  static create(scene: Phaser.Scene) {
    Item.bigItemSound = scene.sound.add('bigItem');

    scene.anims.create({
      key: 'smallHeart',
      frameRate: 8,
      frames: scene.anims.generateFrameNumbers('items', {
        frames: [57, 58],
      }),
      repeat: -1,
    });
  }

  static preload(scene: Phaser.Scene) {
    scene.load.spritesheet('items', 'img/items.png', { frameWidth: 16, frameHeight: 16 });
    scene.load.audio('item', 'audio/item.mp3');
    scene.load.audio('bigItem', 'audio/bigitem.mp3');
  }
}
